export default __webpack_public_path__ + "static/media/hacker.8b7f9f9a.jpeg";